<app-header [label]="page_name"></app-header>

  <div toolbar>
    <div class="flex bg-white gap-4 items-center justify-between p-4 w-full">
      <div class="flex gap-4 flex-1">
        <app-select-input label="University" [is_disabled]="gs.access_scope.locked.university" [depended]="1" class="w-full" [options]="filteredUniversities" (valueChange)="onDropdownChange($event)" (registerSelf)="registerDropdown($event)" [(ngModel)]="params.university_id"></app-select-input>
        <app-select-input label="Academic Year" [depended]="2" class="w-full" [options]="filteredAcademicYears" (valueChange)="onDropdownChange($event)" (registerSelf)="registerDropdown($event)" [(ngModel)]="params.academic_year_id"></app-select-input>
        <app-select-input label="Exam Name" [depended]="3" class="w-full" [options]="filteredExams" (valueChange)="onDropdownChange($event)" (registerSelf)="registerDropdown($event)" [(ngModel)]="params.exam_id"></app-select-input>
        <app-select-input label="Subject Name" [depended]="4" class="w-full" [options]="filteredAssessments" (valueChange)="onDropdownChange($event)" (registerSelf)="registerDropdown($event)" [(ngModel)]="params.assessment_id"></app-select-input>
      </div>
      <div class="flex gap-2">
        <app-search-input *ngIf="list.selected_ids_count <= 0" #searchbar></app-search-input>
        <app-button *ngIf="gs.user_role_data?.assignments_assign_evaluation_assign && list.selected_ids_count > 0" color="bg-secondary text-[#310000] font-semibold px-6" [label]="page_name" (click)="open_form_modal()">
        </app-button>
      </div>
    </div>
    <div *ngIf="levels.length > 0" class="flex items-center justify-between px-4 py-3 bg-white border-b border-gray-100">
      <div class="flex flex-wrap items-center gap-2">
        <span class="font-semibold text-gray-700 mr-1">Evaluation level:</span>
        <button *ngFor="let l of levels" (click)="select_level(l)" [disabled]="!is_level_unlocked(l)" [class]="selected_level === l
            ? 'flex items-center gap-1 px-4 py-1.5 rounded-full text-sm font-semibold bg-[#3F41D1] text-white'
            : is_level_unlocked(l)
              ? 'flex items-center gap-1 px-4 py-1.5 rounded-full text-sm font-medium border border-gray-300 text-gray-600 bg-white hover:bg-gray-50 cursor-pointer'
              : 'flex items-center gap-1 px-4 py-1.5 rounded-full text-sm font-medium border border-gray-200 text-gray-400 bg-gray-50 cursor-not-allowed'">
          <svg *ngIf="!is_level_unlocked(l)" xmlns="http://www.w3.org/2000/svg" class="w-3.5 h-3.5" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
            <path stroke-linecap="round" stroke-linejoin="round" d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z" />
          </svg>
          Level {{ l }}
        </button>
      </div>
      <div class="flex items-center gap-3">
        <span *ngIf="unassigned_count > 0" class="flex items-center gap-1.5 text-sm font-medium text-amber-600 bg-amber-50 border border-amber-200 px-3 py-1.5 rounded-lg">
          <svg xmlns="http://www.w3.org/2000/svg" class="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
            <path stroke-linecap="round" stroke-linejoin="round" d="M12 9v2m0 4h.01M10.29 3.86L1.82 18a2 2 0 001.71 3h16.94a2 2 0 001.71-3L13.71 3.86a2 2 0 00-3.42 0z" />
          </svg>
          Assign all scripts to start evaluation
        </span>
        <span class="text-sm font-medium text-gray-600">Unassigned: <span class="font-medium">{{ unassigned_count }}</span></span>
      </div>
    </div>
  </div>
<app-ag-grid-list #list [list]="items" [colDefs]="columns" [bulk_delete]="false" [hide_bulk_toolbar]="true" height="calc(100vh - 180px)" [itemName]="page_name" [hide_header_when_empty]="true" main_description="No Data Available" description="Please select the dropdown options to view the data." (fetch_new_list)="get_list($event)"></app-ag-grid-list>

<app-modal #form_modal label="Assign Evaluator">
  <form [formGroup]="form">
    <div class="py-2 grid grid-cols-1 gap-4">
      <div>
        <app-detailed-select-input
          class="w-full"
          placeholder="Select Evaluator"
          displayKey="title"
          subDisplayKey="email"
          valueKey="value"
          formControlName="evaluator_id"
          [options]="filtered_evaluator_list"
        ></app-detailed-select-input>
      </div>
    </div>
    <div class="flex justify-end items-center gap-2 mt-2">
      <app-button color="border-primary text-primary" label="Cancel" type="button" (click)="close_form_modal()"></app-button>
      <app-button color="bg-[#3F41D1] text-white font-medium" label="Assign" type="button" [disabled]="isSubmitting || form.invalid" [submit]="submit.bind(this)"></app-button>
    </div>
  </form>
</app-modal>